export default __webpack_public_path__ + "assets/7571eb8088377342614c393717779b94.svg";